import {ConnectableElement, InlineConnectableElement} from '@olive/olive-types';
import ConnectivityHolder from '../ConnectivityHolder';

export default abstract class AbstractDispatcher {
  connectivityHolder: ConnectivityHolder;
  constructor(connectivityHolder: ConnectivityHolder) {
    this.connectivityHolder = connectivityHolder;
  }

  abstract dispatch(props: { id: string, task?: ConnectableElement | InlineConnectableElement, input?: unknown }): Promise<unknown>

  abstract canDispatch(props: { id: string }): boolean
}